module.exports = __webpack_public_path__ + "static/img/11.3bca5f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/11.png
// module id = U9M3
// module chunks = 0